/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons';


// Actions
import {
  loadAgents,
} from '../../../actions/agent';

// Components
import Input from './Input';
import AgencySelect from './AgencySelect';

export default function AddUserDetails() {
  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const {
    adduser: {
      errors,
      validations,
      values,
    },
    user: { is_admin: isAdmin },
    theme: {
      validation,
      features: { agencies: showAgencies },
    },
    agents: {
      sortTerm,
      sortInverse,
    },
  } = useSelector(store => store);

  function close() {
    dispatch({ type: 'CLEAR_ADD_USER' });
    dispatch({ type: 'CLOSE_MODAL', modal: 'addUserOpen' });
    // Reload entire Agent list for proper placement
    loadAgents({ sort: sortTerm, desc: sortInverse });
  }

  function handleChange({ target }) {
    const { checked, id } = target;
    dispatch({ type: 'EDIT_ADD_USER', id, value: checked, valid: true });
  }

  const errorValidations = {
    first_name: validations.first_name,
    middle_name: validations.middle_name,
    last_name: validations.last_name,
    email: validations.email,
    mobile_phone: validations.mobile_phone,
    npn: validations.npn,
    agency: validations.agency,
  };
  const erroring = !Object.values(errorValidations).reduce((prev, curr) => prev && curr, true);

  return (
    <>
      <div className="px-5 py-3 row">
        <div className="col">
          <Input
            id="first_name"
            pattern={validation.first_name}
            label="First Name:"
          />
          <Input
            id="middle_name"
            pattern={validation.middle_name}
            label="Middle Name:"
          />
          <Input
            id="last_name"
            pattern={validation.last_name}
            label="Last Name:"
          />
          {(showAgencies && isAdmin) ? (
            <AgencySelect
              id="agency"
              pattern={validation.agency}
            />
          ) : null}
        </div>
        <div className="col">
          <Input
            id="email"
            // @see https://emailregex.com/
            // eslint-disable-next-line max-len
            pattern={/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/}
            label="Email:"
            feedback="Email already in use."
          />
          <Input
            id="mobile_phone"
            pattern={validation.mobile_phone}
            label="Cell Phone:"
            feedback="Cell Phone must be a valid phone number."
          />
          <Input
            id="npn"
            pattern={validation.npn}
            label="NPN:"
            feedback="NPN already in use."
          />
        </div>
      </div>
      <div className="px-5 pt-1 pb-5 row">
        <div className="d-flex col align-items-end">
          {errors.other && (
            <div className="form-text text-danger">{errors.other}</div>
          )}
          {errors.email && (
            <div className="form-text text-danger">Error: Email already in use</div>
          )}
          {errors.npn && (
            <div className="form-text text-danger">Error: NPN already in use</div>
          )}
        </div>
        <div className="col d-flex justify-content-end align-items-center">
          <div className="me-5">
            <input
              type="checkbox"
              id="is_test_user"
              className="form-check-control"
              checked={values.is_test_user}
              onChange={(e) => handleChange(e)}
            />
            <label htmlFor="is_test_user" className="ms-2 form-check-label">
              QA User
            </label>
          </div>
          <button
            type="button"
            className="px-4 me-3 btn btn-outline-dark"
            onClick={() => close()}
            style={{ maxHeight: '38px' }}
          >
            <FontAwesomeIcon icon={faTimes} size="lg" className="me-2" />
            Cancel
          </button>
          <button
            type="button"
            className="text-white px-4 object-right btn btn-secondary"
            onClick={() => dispatch({ type: 'CHANGE_ADD_USER_PAGE', page: 'permissions' })}
            disabled={erroring}
            style={{ maxHeight: '38px' }}
          >
            Next
          </button>
        </div>
        <div className="mt-2" style={{ textAlign: 'end' }}>
          <small className="font-weight-bold">
            <FontAwesomeIcon icon={faInfoCircle} size="lg" className="me-2" />
            New users will be prompted for password reset at login.
          </small>
        </div>
      </div>
    </>
  );
}
